import type { LoginCredentials, RegisterCredentials } from '@/types/auth'
import { api } from '../api'
import { API_ENDPOINTS, type LoginResponse, logger } from '@myorg/type-lib'

export async function login(data: LoginCredentials): Promise<LoginResponse> {
  logger.log('[authApi.login] ===== START =====')

  const liveCsrfToken = new URLSearchParams(window.location.search).get('csrf') || ''

  const res: LoginResponse = await api().post(
    API_ENDPOINTS.ACCOUNT.LOGIN,
    { ...data },
    {
      headers: {
        'X-XSRF-TOKEN': liveCsrfToken,
        'X-CSRF-Token': liveCsrfToken,
      },
    }
  )

  logger.log('[authApi.login] Login API response:', res.data)
  logger.log('[authApi.login] ===== END =====')

  return res
}

export interface CaptchaInitData {
  captchaId: string
  bg: string
  slice: string
  target: number
  y: number
}

export const initCaptcha = async (): Promise<CaptchaInitData | undefined> => {
  const res = await api().get('/api/go-bff-service/public/captcha/init')

  if (res?.data?.data) {
    return res.data.data as CaptchaInitData
  }

  return undefined
}

export const logout = async () => {
  const res = await api().post('/api/client/logout')
  return res.data
}

export async function register(
  data: RegisterCredentials
): Promise<LoginResponse> {
  const res: LoginResponse = await api().post(
    API_ENDPOINTS.ACCOUNT.REGISTER,
    { ...data }
  )

  return res
}

export async function getCurrentUser() {
  const res = await api().get(API_ENDPOINTS.CLIENT.ME)
  return res.data
}
